import { usePaginationFilter } from 'shared/lib/pagination';
import { useAppSelector } from 'shared/lib/store';
import { Filter } from '../types';
import {
	selectPersonSlugTagsMap,
	selectPersonTagsOptions,
	selectPersonTagsSlugNamesMap,
} from 'entities/tags';
import { useEffect, useState } from 'react';
import { Option } from 'shared/types';
import { MultiValue } from 'react-select';
import { PaginationHook } from 'shared/lib/pagination';

export const usePersonFilter = () => {
	const filters = usePaginationFilter()?.filters as unknown as Filter;
	const { resetFilters, updateFilters } =
		usePaginationFilter() as PaginationHook;

	const tagsOptions = useAppSelector(selectPersonTagsOptions);
	const tagsSlugsMap = useAppSelector(selectPersonSlugTagsMap);
	const tagsSlugMap = useAppSelector(selectPersonTagsSlugNamesMap);
	const [selectedTagsOptions, setTagsOptions] = useState<Option[] | []>([]);

	const changeTags = (tagsOptions: MultiValue<Option>) => {
		const tags = tagsOptions.map(tag => tagsSlugMap.get(tag.label));

		if (!tags.length) {
			delete filters.tags;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			updateFilters({ tags });
		}
	};

	const reset = () => {
		resetFilters({});
		setTagsOptions([]);
	};

	useEffect(() => {
		if (filters) {
			if (filters.tags) {
				const tagsOptions = filters.tags.map(tag => {
					const newTag = tagsSlugsMap.get(tag);
					return {
						label: newTag?.name || '',
						value: newTag?.color || '',
					};
				});

				setTagsOptions(tagsOptions);
			} else {
				setTagsOptions([]);
			}
		}
	}, [filters, tagsSlugsMap]);

	return {
		filters,
		tagsOptions,
		selectedTagsOptions,
		changeTags,
		reset,
	};
};
